import { Component, Input } from '@angular/core';
import {
  CompanyBenefitPolicyRequiredFieldDTO,
  CompanyBenefitPolicyRequiredFieldTypeEnum,
  RequiredFieldState,
} from 'app/core/models/company-benefit-policy';
import { OrderRequiredFieldSubmissionModel } from 'app/core/models/order-policy-submission';

@Component({
  selector: 'app-required-fields',
  templateUrl: './required-fields.component.html',
  styleUrls: ['./required-fields.component.scss'],
})
export class RequiredFieldsComponent {
  private _fields: RequiredFieldState[] = [];

  @Input() fieldErrors: Record<number, string> = {};

  readonly fieldTypes = CompanyBenefitPolicyRequiredFieldTypeEnum;

  @Input() set fields(value: CompanyBenefitPolicyRequiredFieldDTO[]) {
    const previousMap = new Map(this._fields.map((f) => [f.id, f]));
    this._fields = (value || [])
      .sort((a, b) => a.displayOrder - b.displayOrder)
      .map((item) => {
        const previous = previousMap.get(item.id);
        const value = previous?.value ?? '';
        return {
          ...item,
          value,
        };
      });
  }

  get fieldStates(): readonly RequiredFieldState[] {
    return this._fields;
  }

  onFieldInput(field: RequiredFieldState): void {
    if (this.fieldErrors[field.id]) {
      delete this.fieldErrors[field.id];
    }
  }

  public getSubmittedFields(): Array<OrderRequiredFieldSubmissionModel> {
    return this._fields.map((field) => ({
      requiredFieldId: field.id,
      fieldLabel: field.fieldLabel,
      value: field.value,
    }));
  }
}
